@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}
@if (mode === 'edit') {
  <app-widget-notes-editor
    [widgetHeight]="widgetHeight"
    [condensed]="widget.rows < 5"
    [content]="text"
    [mode]="widget.payload.inputMode"
    (contentChange)="onTextChange($event)"
    (editFinished)="onEditFinished()"
  ></app-widget-notes-editor>
}
@if (!isLoading && mode === 'view') {
  <div #widgetContainer class="widget-notes__view" [froalaView]="text"></div>
}
